import { makeStyles } from "@material-ui/core";
import * as React from "react";
import {
  Create,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";
import TranslationInputs from "../../components/translationInputs/translationInputs.component";
import { PublishingStatus } from "../../shared/enums/publishing-status.enum";

export const TermsCreate = (props: any) => {
  const statusOptions = Object.keys(PublishingStatus).map((key) => ({
    id: PublishingStatus[key],
    name: key,
  }));

  return (
    <Create {...props}>
      <SimpleForm variant="outlined" margin="none">
        <SelectInput
          source="status"
          validate={[required()]}
          choices={statusOptions}
        />
        <TextInput source="name" validate={[required()]} fullWidth />
        <TextInput source="title" validate={[required()]} fullWidth />
        <TextInput
          source="terms"
          rows={8}
          multiline={true}
          fullWidth={true}
          validate={[required()]}
        />

        <TranslationInputs {...props}>
          <TextInput
            source="title_en"
            label="Title eng"
            fullWidth
            validate={[required()]}
          />
          <TextInput
            source="terms_en"
            label="Terms eng"
            rows={8}
            multiline={true}
            fullWidth={true}
            validate={[required()]}
          />
        </TranslationInputs>
      </SimpleForm>
    </Create>
  );
};
